import { createReducer } from "@reduxjs/toolkit";
import { createTeacherStudio, resetCreateTeacherStudio } from "./create-teacher-studio";
import type { CreationState } from "@redux/state/shared-types";

const initialState: CreationState = {
  processing: "idle",
  justCreatedId: null,
};

export const createTeacherStudioReducer = createReducer(initialState, builder => {
  builder
    .addCase(createTeacherStudio.pending, state => {
      state.processing = "pending";
    })
    .addCase(createTeacherStudio.fulfilled, (state, action) => {
      state.processing = "success";
      state.justCreatedId = action.payload;
    })
    .addCase(createTeacherStudio.rejected, state => {
      state.processing = "failed";
    })
    .addCase(resetCreateTeacherStudio, () => {
      return initialState;
    });
});
